import {
  HttpErrorResponse,
  HttpInterceptorFn
} from '@angular/common/http';

import { inject } from '@angular/core';
import { Router } from '@angular/router';

import {
  catchError,
  throwError
} from 'rxjs';

export const authInterceptor:
HttpInterceptorFn = (req, next) => {

  const router = inject(Router);

  const token =
    localStorage.getItem('token');

  // Skip login APIs
  const ignoredUrls = [
    '/sendEmailOtp',
    '/verifyEmailOtp'
  ];

  const isIgnored =
    ignoredUrls.some(url =>
      req.url.includes(url)
    );

  if (!isIgnored && token) {

    req = req.clone({

      setHeaders: {

        Authorization:
          `Bearer ${token}`

      }

    });

  }

  return next(req).pipe(

    catchError((error: HttpErrorResponse) => {

      // GLOBAL 401 HANDLING
      if (error.status === 401) {

        // Clear session
        sessionStorage.clear();
        localStorage.clear();

        // Prevent redirect loop
        if (router.url !== '/') {

          router.navigate(['/login']);

        }
      }

      return throwError(() => error);

    })

  );

};